import { PackageNamespace } from '@tablekit/package-namespace';
var inlineDialogThemeNamespace = PackageNamespace.InlineDialog;
var inlineDialogClassicTheme = {
  backgroundColor: function backgroundColor(_ref) {
    var theme = _ref.theme;
    return theme.colors.surface;
  },
  textColor: function textColor(_ref2) {
    var theme = _ref2.theme;
    return theme.colors.text;
  }
};
var inlineDialogDarkTheme = inlineDialogClassicTheme;
export { inlineDialogClassicTheme, inlineDialogDarkTheme, inlineDialogThemeNamespace };
